import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import {
    Box, Flex, Link, Text
} from 'components/ui';
import { radii } from 'style/config';
import BenefitIconList from 'components/Content/BeautyInsider/BeautyInsiderBenefits/BenefitIconList';
import Empty from 'constants/empty';
import getBenefitsViewState from 'components/Content/BeautyInsider/BeautyInsiderBenefits/benefitsViewState';

const getSection = props => getBenefitsViewState(props).nextTier;
const getHref = link => link?.href || link?.url || link?.targetUrl;
const getLabel = link => link?.label || link?.text || link?.title;

const isSignedInTier = state => {
    if (typeof state?.isSignedInTier === 'boolean') {
        return state.isSignedInTier;
    }

    return Boolean(state?.tier || state?.currentTier || state?.biTier);
};

/**
 * Renders signed-in aspirational Benefits for the next reachable BI tier from Benefits view state.
 */
const NextTierBenefitsSection = props => {
    const state = getBenefitsViewState(props);
    const section = getSection(props);
    const benefits = section?.benefits || Empty.Array;
    const action = section?.action || section?.link;
    const actionHref = getHref(action);

    if (!section?.title || !benefits.length || !isSignedInTier(state)) {
        return null;
    }

    return (
        <Box
            is='section'
            backgroundColor='nearWhite'
            borderRadius={radii[2]}
            padding={[4, 5]}
            marginBottom={[4, 5]}
            data-at={Sephora.debug.dataAt('bi_benefits_next_tier')}
        >
            <Flex
                alignItems={['flex-start', 'center']}
                justifyContent='space-between'
                flexDirection={['column', 'row']}
                gap={3}
                marginBottom={4}
            >
                <Box>
                    <Text
                        is='h2'
                        fontWeight='bold'
                        fontSize={['md', 'lg']}
                        lineHeight='tight'
                        marginBottom={section.description ? 2 : 0}
                        children={section.title}
                    />
                    {section.description && (
                        <Text
                            is='p'
                            color='gray'
                            lineHeight='tight'
                            children={section.description}
                        />
                    )}
                </Box>
                {actionHref && (
                    <Link
                        href={actionHref}
                        color='blue'
                        children={getLabel(action)}
                    />
                )}
            </Flex>
            <BenefitIconList
                benefits={benefits}
                columns={3}
            />
        </Box>
    );
};

export default wrapFunctionalComponent(NextTierBenefitsSection, 'NextTierBenefitsSection');
